<template>
  <router-view />
</template>

<style>
:root {
  --gooval-primary: #0d9488;
  --gooval-primary-dark: #0f766e;
  --gooval-surface: #f4f6f9;
  --gooval-header: #0f172a;
  --el-color-primary: #0d9488;
  --el-color-primary-light-3: #37a99e;
  --el-color-primary-dark-2: #0f766e;
}

html,
body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
}

#app {
  min-height: 100vh;
  background: var(--gooval-surface);
  background-image:
    radial-gradient(ellipse 80% 50% at 50% -20%, rgba(13, 148, 136, 0.12), transparent),
    linear-gradient(180deg, #eef2f7 0%, var(--gooval-surface) 240px);
}
</style>
